module.exports = __webpack_public_path__ + "static/media/vf_wdress_core.fbc47c15.svg";